import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { httpPost, httpUrl } from '../api/httpClient';
import EventModal from '../components/modal/EventModal';
import PaymentChangeModal from '../components/modal/PaymentChangeModal';
import {
  CardList,
  CardStatics,
  CashList,
  CompleteList,
  ProcList,
} from '../components/order';
import ReserveList from '../components/order/ReserveList';
import Const from '../const';
import { orderStatusCode } from '../lib/util/codeUtil';
import Event from '../pages/etc/Event';
import { getEventBannerList } from "../api/api";
import moment from "moment";

class Delivery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listType: 0,
      paymentChangeModalOpen: false,

      orderCount: 0,
      assignCount: 0,
      pickupCount: 0,
      notCheckedCnt: 0,
      deliveryStatShow: null,

      eventBannerShow: false,
      joinAbleCount: 0,
      eventIdx: null,
      showResult: false,
    };
    this.formRef = React.createRef();
  }

  async componentDidMount() {
    this.setDeliveryStatShow();
    const res = await getEventBannerList();
    const eventList = res.data?.eventList;
    if (typeof eventList !== 'object' || eventList.length === 0) return;
    const event = eventList[0];

    if (res.result === 'SUCCESS') {
      const startDate = moment(event.bannerStartDate);
      const endDate = moment(event.bannerEndDate);
      const resultStartDate = moment(event.resultStartDate);
      const resultEndDate = moment(event.resultEndDate);
      const now = new moment();

      if (
        (now.isAfter(startDate) && now.isBefore(endDate)) ||
        (now.isAfter(resultStartDate) && now.isBefore(resultEndDate))
      )
        this.setState({
        eventBannerShow: true,
        joinAbleCount: event.joinAbleCount,
        eventIdx: event.idx,
      })
      if (
        now.isAfter(resultStartDate) &&
        now.isBefore(resultEndDate)
      )
        this.setState({
        showResult: true,
      })
    }
  }

  componentWillUnmount() {
    if (this.orderStatusTimeInterval) {
      clearInterval(this.orderStatusTimeInterval);
    }
  }

  updateOrderStatus = () => {
    this.getOrderStatusAsync().then((data) => {
      if (data === null) {
        return;
      }

      const { orderStatusCnts, notCheckedCnt } = data;

      let orderCount = 0;
      let assignCount = 0;
      let pickupCount = 0;

      if (orderStatusCnts !== null) {
        orderStatusCnts.forEach((info) => {
          switch (info.orderStatus) {
            case orderStatusCode.order:
              orderCount = info.orderCnt;
              break;
            case orderStatusCode.assign:
              assignCount = info.orderCnt;
              break;
            case orderStatusCode.pickup:
              pickupCount = info.orderCnt;
              break;
            default:
              break;
          }
        });
        this.setState({ orderCount, assignCount, pickupCount, notCheckedCnt });
      }
    });
  };
  getOrderStatusAsync = async () => {
    const res = await httpPost(httpUrl.orderStatus, [], {}, true);
    if (res.result !== 'SUCCESS') {
      return null;
    }
    if (res.data === null) {
      return null;
    }
    return {
      orderStatusCnts: res.data.orderStatusCnts,
      notCheckedCnt: res.data.notCheckedCnt,
    };
  };

  setDeliveryStatShow = async () => {
    const deliveryStatShow = await reactLocalStorage.getObject(
      Const.appName + '#deliveryStatShow'
    );

    if (typeof deliveryStatShow !== 'boolean') {
      this.setState({
        deliveryStatShow: false,
      });
      return;
    }
    this.setState(
      {
        deliveryStatShow,
      },
      () => {
        if (this.state.deliveryStatShow) {
          this.updateOrderStatus();
          this.orderStatusTimeInterval = setInterval(() => {
            this.updateOrderStatus();
          }, 10000);
        }
      }
    );
  };

  // 결제변경건 모달
  // openPaymentChangeModal = () => {
  //   this.setState({ paymentChangeModalOpen: true });
  // };
  // closePaymentChangeModal = () => {
  //   this.setState({ paymentChangeModalOpen: false });
  // };
  renewNotCheckedCnt = (cnt) => {
    this.setState({ notCheckedCnt: cnt });
  };

  render() {
    const skinType = Const.skinType.toUpperCase();
    return (
      <div className="delivery">
        <div className="delivery-main">

          {/* 상단 */}
          <div className="delivery-content">
            <div className="delivery-content-all">
              <div
                className="delivery-content-title"
                onClick={() => {
                  this.setState({ listType: 0 });
                }}>
                <div
                  className={this.state.listType === 0 && skinType === "GOGOIT" ?
                        'gogoit-delivery-content-title-text-color'
                      : this.state.listType === 0
                      ? 'delivery-content-title-text-color'
                      : 'delivery-content-title-text'
                  }>
                  진행중 배달
                </div>
              </div>
              <div
                className="delivery-content-title2"
                onClick={() => {
                  this.setState({ listType: 1 });
                }}>
                <div
                  className={this.state.listType === 1 && skinType === "GOGOIT" ?
                      'gogoit-delivery-content-title2-text-color'
                      : this.state.listType === 1
                      ? 'delivery-content-title2-text-color'
                      : 'delivery-content-title2-text'
                  }>
                  완료된 배달
                </div>
              </div>
              <div
                className="delivery-content-title3"
                onClick={() => {
                  this.setState({ listType: 2 });
                }}>
                <div
                  className={this.state.listType === 2 && skinType === "GOGOIT" ?
                      'gogoit-delivery-content-title3-text-color'
                      : this.state.listType === 2
                      ? 'delivery-content-title3-text-color'
                      : 'delivery-content-title3-text'
                  }>
                  카드내역
                </div>
              </div>
              <div
                className="delivery-content-title4"
                onClick={() => {
                  this.setState({ listType: 5 });
                }}>
                <div
                  className={this.state.listType === 5 && skinType === "GOGOIT" ?
                      'gogoit-delivery-content-title4-text-color'
                      : this.state.listType === 5
                      ? 'delivery-content-title4-text-color'
                      : 'delivery-content-title4-text'
                  }>
                  예약주문
                </div>
              </div>
              {/*
              <div
                className="delivery-content-title3"
                onClick={() => {
                  this.setState({ listType: 4 });
                }}
              >
                <div
                  className={
                    this.state.listType === 4
                      ? "delivery-content-title3-text-color"
                      : "delivery-content-title3-text"
                  }
                >
                  현금내역
                </div>
              </div> */}

              <div className="delivery-content-btn-right">
                <PaymentChangeModal
                  renew={this.renewNotCheckedCnt}
                  isOpen={this.state.paymentChangeModalOpen}
                  close={this.closePaymentChangeModal}
                />

                {this.state.deliveryStatShow && (
                  <>
                    <div className="delivery-content-btn" onClick={() => {}}>
                      전체
                      <div className="delivery-content-btn-text">
                        {this.state.orderCount +
                          this.state.assignCount +
                          this.state.pickupCount}
                        {/* 256 */}
                      </div>
                    </div>
                    <div className="delivery-content-btn2" onClick={() => {}}>
                      접수
                      <div className="delivery-content-btn2-text">
                        {this.state.orderCount}
                        {/* 88 */}
                      </div>
                    </div>
                    <div className="delivery-content-btn3" onClick={() => {}}>
                      배차완료
                      <div className="delivery-content-btn3-text">
                        {this.state.assignCount}
                        {/* 110 */}
                      </div>
                    </div>
                    <div className="delivery-content-btn4" onClick={() => {}}>
                      픽업완료
                      <div className="delivery-content-btn4-text">
                        {this.state.pickupCount}
                        {/* 58 */}
                      </div>
                    </div>
                  </>
                )}
                {/* <Badge count={this.state.notCheckedCnt}>
                  <div
                    className="body-content-title-right"
                    onClick={this.openPaymentChangeModal}
                  >
                    결제변경건
                  </div>
                </Badge> */}
              </div>
            </div>

          </div>

          {/* 배달 진행중 목록 */}
          {this.state.listType === 0 && (
            <ProcList
              waitingOrders={this.props.posReducer.waitingOrders}
              posOrders={this.props.posReducer.posOrders}
            />
          )}

          {/* 완료된 배달목록 */}
          {this.state.listType === 1 && <CompleteList />}

          {/* 카드 결제내역 목록 */}
          {this.state.listType === 2 && <CardList />}

          {/* 카드 결제 통계 목록 */}
          {this.state.listType === 3 && <CardStatics />}

          {/* 현금 결제내역 목록 */}
          {this.state.listType === 4 && <CashList />}

          {/* 예약주문 목록 */}
          {this.state.listType === 5 && <ReserveList />}

          {this.state.eventBannerShow && (
            <Event
              showResult={this.state.showResult}
              joinAbleCount={this.state.joinAbleCount}
              eventIdx={this.state.eventIdx}
            />
          )}
        </div>

        {/* <EventModal></EventModal> */}

        {/*<Image src={require("../img/event/kiosk_event_banner.png")} />*/}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer, posReducer } = state;
  return { loginReducer, posReducer };
};

export default withRouter(connect(mapStateToProps, null)(Delivery));
